import React, { createContext, useMemo, useState } from 'react';

const defaultSpinnerEventHandlers = {
  handleClickImmersiveButton() {}
};

const defaultContext = {
  hasSpinnerOverflow: false,
  isHotspotSelected: false,
  isViewingInterior: false,
  setHotspotSelected: (_: boolean) => {},
  setSpinnerEventHandlers: (_: typeof defaultSpinnerEventHandlers) => {},
  setSpinnerOverflow: (_: boolean) => {},
  setViewingInterior: (_: boolean) => {},
  spinnerEventHandlers: defaultSpinnerEventHandlers
};

export type ContextType = typeof defaultContext;

const HeroContext = createContext<ContextType>(defaultContext);

export function HeroContextProvider({ children }: React.PropsWithChildren) {
  const [hasSpinnerOverflow, setSpinnerOverflow] = useState(
    defaultContext.hasSpinnerOverflow
  );
  const [isHotspotSelected, setHotspotSelected] = useState(
    defaultContext.isHotspotSelected
  );
  const [isViewingInterior, setViewingInterior] = useState(
    defaultContext.isViewingInterior
  );
  const [spinnerEventHandlers, setSpinnerEventHandlers] = useState(
    defaultContext.spinnerEventHandlers
  );

  const value = useMemo<ContextType>(
    (): ContextType => ({
      hasSpinnerOverflow,
      isHotspotSelected,
      isViewingInterior,
      setHotspotSelected,
      setSpinnerEventHandlers,
      setSpinnerOverflow,
      setViewingInterior,
      spinnerEventHandlers
    }),
    [
      hasSpinnerOverflow,
      isHotspotSelected,
      isViewingInterior,
      spinnerEventHandlers
    ]
  );

  return <HeroContext.Provider value={value}>{children}</HeroContext.Provider>;
}

HeroContextProvider.displayName = 'HeroContextProvider';

export default HeroContext;
